module.exports = __webpack_public_path__ + "img/projects.e60165d1.png";